import {
  shipperTypesSelector,
  updateLabelConfig,
} from '../../../data/labelInfos/index.js'
import ConfigCheckbox, {
  onCheckboxLabelPropertyEnable,
} from './ConfigCheckbox.js'
import {
  AMAZON_SHIPPER,
  FEDEX,
  FEDEX_360,
  UPS,
} from '../../../common/constants/ShipperNames.js'
import {useLabelConfigContext} from '../LabelConfigContext.js'
import {useSelector} from '../../../store.js'
import {includesSome} from '../../../common/utils.js'
import {
  defaultValidLabelPropertiesFunc,
  EMPTY_DEPENDENT_PROPERTIES_FUNC,
} from './useLabelProperty.js'

const LABEL_PROPERTY = 'recipient_address_is_residential'
const VALID_SHIPPER_TYPES = [AMAZON_SHIPPER, FEDEX, FEDEX_360, UPS]

export default function ResidentialAddress() {
  const {labelInfoID, shipperType, onChange} = useLabelConfigContext()
  const propertySpecs = ResidentialAddress.propertySpecList[0]
  const [labelProperty] = propertySpecs.labelPropertiesFunc(
    shipperType,
    labelInfoID,
  )
  const shipperTypes = useSelector((state) =>
    shipperTypesSelector(state, {labelInfoID}),
  )

  // this component is put outside the normal additional options
  // so let it see all shipper types
  // and let single shipper type work if that ever is a thing (it's not set normally)
  const hide = !includesSome(
    VALID_SHIPPER_TYPES,
    shipperType ? [shipperType] : shipperTypes,
  )

  return (
    <ConfigCheckbox
      label="Residential Address"
      onChange={(checked) => {
        updateLabelConfig(labelInfoID, {[labelProperty]: checked})

        onChange()
      }}
      labelProperty={labelProperty}
      propertySpecs={propertySpecs}
      hide={hide}
    />
  )
}

ResidentialAddress.propertySpecList = [
  {
    validShipperTypes: VALID_SHIPPER_TYPES,
    labelPropertiesFunc() {
      return [LABEL_PROPERTY]
    },
    dependentPropertiesFunc: EMPTY_DEPENDENT_PROPERTIES_FUNC,
    validLabelPropertiesFunc: defaultValidLabelPropertiesFunc,
    onLabelPropertyEnable: onCheckboxLabelPropertyEnable,
  },
]
